import React from "react";
import logo from "../../assets/img/Main logo.png";
import logoNdovu from "../../assets/img/Main logo_ndovu.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import svg72 from "../../assets/svg/svg72.svg";

function Header() {
  const navigate = useNavigate();
  const handleLogin = () => {
    navigate("/login");
  };
  const loc = useLocation();
  
  const { subdomain } = useSelector((state) => state.global);
  return (
    <div className=" px-[2.06rem] py-[1.88rem] w-full">
      <img
        src={
          subdomain === "ndovupay"
            ? logoNdovu
            : subdomain === "bovepay"
            ? logo
            : logo
        }
        className="w-[7.125rem] h-[1.6875rem] object-cover cursor-pointer"
        alt="image2"
        onClick={handleLogin}
      />
      {loc?.pathname !== "/login" &&
        loc?.pathname !== "#/login" &&
        loc?.pathname !== "/" &&
        loc?.pathname !== "#/" && (
          <div className="mt-[3.41rem]">
            <img
              src={svg72}
              alt="svg72"
              className="cursor-pointer"
              onClick={() => navigate(-1)}
            />
          </div>
        )}
    </div>
  );
}

export default Header;
